import { SocialMediaLinksBase } from "./SocialMediaLinksBase/SocialMediaLinksBase";

export default function SocialMediaLinksPage() {
  return <SocialMediaLinksBase isEdit={false} />;
}
